import { HTTP } from '../core/http';
import { setPrize } from '../reducers/_dispatchers';

export const getPrize = (Data) => {
    HTTP({
        method: 'GET',
        data: {},
        url: `https://ha-back.demasys.net/api/pinata/get_trivia?social_id=${Data.profileID}`
        // url: 'https://api-lamoderna.socialand-labs.com/api/PinataTemporal/get_trivia?id_promo=8'
    }).then((response) => {
        const responseData = response && response.data && response.data.data && response.data.status ? response.data.data : false;
        if(responseData) {
            setPrize(responseData);
        }
    }).catch((error) => {
        console.log(error);
    });
};
